<script setup>
const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div class="item col-12 col-640-6 col-1200-3 px-4">
    <div class="item__icon-container">
      <div class="item__icon">
        <img
          :src="props.icon"
          alt="icon"
          loading="lazy"
          width="25"
          height="25"
        >
      </div>
    </div>
    <h3 class="scale-2 item__title">
      {{ props.title }}
    </h3>
    <div class="equal-base item__text">
      {{ props.text }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.item {
  text-align: center;
  margin-bottom: 35px;

  &__icon-container {
    height: clamp(50px, 0.69vw + 47.78px, 60px);
    width: clamp(50px, 0.69vw + 47.78px, 60px);
    margin: auto;
    border-radius: 100%;
    border: 1px solid $color-dark-disabled;
  }

  &__icon {
    margin: auto;
    height: 100%;
    display: flex;

    img {
      margin: auto;
      max-height: clamp(30px, 0.42vw + 28.67px, 36px);
      max-width: clamp(30px, 0.42vw + 28.67px, 36px);
    }
  }

  &__title {
    margin-top: 20px;
  }

  &__text {
    margin-top: 20px;
  }
}
</style>
